import { render, staticRenderFns } from "./EventContestEntry.vue?vue&type=template&id=15a9fd84&scoped=true"
import script from "./EventContestEntry.vue?vue&type=script&lang=ts"
export * from "./EventContestEntry.vue?vue&type=script&lang=ts"
import style0 from "./EventContestEntry.vue?vue&type=style&index=0&id=15a9fd84&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a9fd84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15a9fd84')) {
      api.createRecord('15a9fd84', component.options)
    } else {
      api.reload('15a9fd84', component.options)
    }
    module.hot.accept("./EventContestEntry.vue?vue&type=template&id=15a9fd84&scoped=true", function () {
      api.rerender('15a9fd84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/EventContestEntry.vue"
export default component.exports